<template>
  <div>
  <div class="flex" style="align-items: center">
    <select v-model="barcodeType" class="box mr2">
      <option
        v-for="option in barcodeTypes"
        :key="option.value"
        :value="option.value"
      >{{option.text}}</option>
    </select>

    <input
      v-model.trim="barcode"
      placeholder="Enter Barcode"
      class="box"
      style="text-align: left; flex-grow: 1"
      @blur="submit"
    />
  </div>
    <p v-if="!isValid">Code is not valid {{ barcodeType }}</p>
  </div>
</template>

<script>
import CONSTANTS from '@/constants/constants';
import { findBarcodeType } from '@/utils/barcodes';

export default {
  name: 'BarcodeForm',
  props: {
    value: { type: Object, required: true },
  },

  data() {
    return {
      isValid: true,
      barcode: this.value.barcode,
      barcodeType: (findBarcodeType(this.value.barcode) || CONSTANTS.barcodeTypes.EAN).value,
      barcodeTypes: Object.values(CONSTANTS.barcodeTypes),
    };
  },

  watch: {
    barcodeType() {
      this.submit();
    },

    barcode() {
      if (!this.isValid) {
        this.validate();
      }
    },
  },

  methods: {
    async validate() {
      const currentType = this.barcodeTypes.find(({ value }) => this.barcodeType === value);
      if (currentType) {
        this.isValid = currentType.validate(this.barcode);
      } else {
        this.isValid = false;
      }
    },

    async submit() {
      await this.validate();
      this.setBarcodeToCoupon(this.isValid ? this.barcode : null);
    },

    setBarcodeToCoupon(barcode) {
      this.$emit('input', {
        ...this.value,
        barcode,
      });
    },
  },
};
</script>
